import { IClientApiDependencySegment } from '@cbridge-packages/api';
import { Observable, of, expand, EMPTY, skip, reduce } from 'rxjs';
import { fetchDictSymbols } from './fetchDictSymbols';
import { IDictSymbolsKey } from '../dictSymbol.interface';

type IDependencies = IClientApiDependencySegment;

export interface IDictSymbolsQueryParams extends IDictSymbolsKey {
  limit: number;
  skip: number;
  isLastPage?: boolean;
}

export const fetchDictSymbolsRecursively = (
  initialQueryParams: IDictSymbolsQueryParams,
  dependencies: IDependencies,
): Observable<string[]> => {
  return of(initialQueryParams).pipe(
    expand(({ limit, skip, search, isLastPage }) => {
      return isLastPage
        ? EMPTY
        : fetchDictSymbols({ limit, skip, search }, dependencies);
    }),
    skip(1),
    reduce((symbols, { symbols: nextSymbols }) => {
      return symbols.concat(nextSymbols);
    }, [] as string[]),
  );
};
